<cass-core-toolbar></cass-core-toolbar>
<div class="home-component-container">
	<h1 *ngIf="!(authService.authStatus$ | async)?.isAuthenticated">{{ "HOME.GUEST_HEADING" | translate }}</h1>
	<h1 *ngIf="(authService.authStatus$ | async)?.isAuthenticated">{{ "HOME.USER_HEADING" | translate: {username: (authService.authStatus$ | async)?.displayName} }}</h1>
	<div class='branding--home--above-cards' [innerHTML]='brandingAboveCards'></div>
	<div class='action-cards'>
		<mat-card *ngIf="(appConfigService.config$ | async)?.guestCanBuildAd" class="branding--home--action-card branding--action-card">
			<mat-card-content>
				<div class='action-card'>
					<div class='branding--home--action-card-image branding--home--create-ad-image'></div>
					<h2>{{ "HOME.CREATE_AD_CARD_TITLE" | translate }}</h2>
					<p>{{ "HOME.CREATE_AD_CARD_DESCRIPTION" | translate }}</p>
					<button mat-raised-button color='primary' (click)="createNew()">{{ "HOME.CREATE_AD_CARD_ACTION" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card *ngIf="(appConfigService.config$ | async)?.loginEnabled && !(authService?.authStatus$ | async)?.isAuthenticated" class="branding--home--action-card branding--action-card">
			<mat-card-content>
				<div class='action-card'>
					<div class='branding--home--action-card-image branding--home--account-image'></div>
					<h2>{{ "HOME.YOUR_ACCOUNT_CARD_TITLE" | translate }}</h2>
					<p *ngIf="(appConfigService.config$ | async)?.registrationEnabled">{{ "HOME.YOUR_ACCOUNT_CARD_DESCRIPTION" | translate }}</p>
					<button mat-raised-button color='primary' routerLink='/login'>{{ "HOME.YOUR_ACCOUNT_CARD_ACTION_LOGIN" | translate }}</button>
					<button *ngIf="(appConfigService.config$ | async)?.registrationEnabled" mat-raised-button color='primary' routerLink='/register'>{{ "HOME.YOUR_ACCOUNT_CARD_ACTION_CREATE_ACCOUNT" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class='branding--home--below-cards' [innerHTML]='brandingBelowCards'></div>
</div>
<div class='branding--home--footer'></div>
